import t from '@instructure/quiz-i18n/es/format-message';
export var getFailedToFetchReports = function getFailedToFetchReports() {
  return t('An error has occurred while loading this report. Please refresh the page.');
};
export var getFailedToExportReports = function getFailedToExportReports() {
  return t('An error has occurred while exporting this report. Please try again.');
};
export var getLastReportGenerationFailed = function getLastReportGenerationFailed() {
  return t('Report generation failed. Please try again.');
};
export var getReportGenerationFailure = function getReportGenerationFailure() {
  return t('An error has occurred while generating this report. Please try again.');
};
export var getInsufficientSubmissionNumberError = function getInsufficientSubmissionNumberError() {
  return t('There is not enough data available to generate this report. A minimum of 3 submissions is required to generate. Please try again when more submissions are available.');
};
export var getOngoingReportGenerationError = function getOngoingReportGenerationError() {
  return t('A report for this quiz is currently being generated by another user. Please try again later.');
};
export var getMinimumThreeGradedSubmissionError = function getMinimumThreeGradedSubmissionError() {
  return t('There is not enough data available to generate this report. A minimum of 3 fully graded submissions is required to generate. Please try again when more submissions are graded.');
};
export var getNotEnoughDataAvailableError = function getNotEnoughDataAvailableError() {
  return t('There is not enough data available to generate this report. Please try again when more submissions are graded.');
};